import React, { useContext, useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import STcontext from "../context/STcontext";
import ThreeDot from "../loading/Three dots/Three_dot";

// Convertit une date backend ("2026-10-12 10:30:00") vers un format
// accepté par un input datetime-local ("2026-10-12T10:30").
const toInputDate = (value) => {
   if (!value) return "";
   return String(value).replace(" ", "T").slice(0, 16);
};

// Convertit une valeur d'input datetime-local ("2026-10-12T10:30")
// vers un format accepté par la base ("2026-10-12 10:30:00").
const toBackendDate = (value) => {
   if (!value) return value;
   const converted = String(value).replace("T", " ");
   return converted.length === 16 ? `${converted}:00` : converted;
};

// Edition d'une tâche à confirmer par le support technique,
// SANS la confirmer (endpoint PUT /api/supportTechnique/updateTask/{id}).
const UpdateTaskToConfirmed = ({ taskToUpdate }) => {
   const { NewTask, updateTaskFromST, isLoading } = useContext(STcontext);

   const [modalShow, setModalShow] = useState(false);
   const [newDataTask, setNewDataTask] = useState({});
   const [UpdateTask, setUpdateTask] = useState({
      id: taskToUpdate.id,
      client_name: taskToUpdate.nomComplet,
      phoneNumber: taskToUpdate.telephone_client,
      catache: taskToUpdate.catache,
      date_previsionnelle_debut: toInputDate(
         taskToUpdate.date_previsionnelle_debut
      ),
      user_name: "",
      cityClient: taskToUpdate.city_id,
      observation: taskToUpdate.observation,
   });

   const filteredUsers =
      NewTask && NewTask.Users
         ? NewTask.Users.filter(
              (user) => user.profil_id === 1 || user.profil_id === 2
           )
         : [];

   const currentCity =
      NewTask && NewTask.Cities
         ? NewTask.Cities.find((city) => city.id === taskToUpdate.city_id)
         : null;

   // La tâche a été rafraîchie : on resynchronise le formulaire.
   useEffect(() => {
      setUpdateTask({
         id: taskToUpdate.id,
         client_name: taskToUpdate.nomComplet,
         phoneNumber: taskToUpdate.telephone_client,
         catache: taskToUpdate.catache,
         date_previsionnelle_debut: toInputDate(
            taskToUpdate.date_previsionnelle_debut
         ),
         user_name: "",
         cityClient: taskToUpdate.city_id,
         observation: taskToUpdate.observation,
      });
      setNewDataTask({});
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [taskToUpdate]);

   const handleClose = () => {
      setModalShow(false);
      setNewDataTask({});
   };

   const handleChange = (e) => {
      const name = e.target.name;
      const value = e.target.value;
      setUpdateTask({ ...UpdateTask, [name]: value });
      setNewDataTask({ ...newDataTask, [name]: value });
   };

   const handleSubmit = async (e) => {
      e.preventDefault();
      // Aucune modification : on ferme sans appeler le backend.
      if (Object.keys(newDataTask).length === 0) {
         handleClose();
         return;
      }
      const payload = { ...newDataTask };
      if (payload.date_previsionnelle_debut) {
         payload.date_previsionnelle_debut = toBackendDate(
            payload.date_previsionnelle_debut
         );
      }
      const success = await updateTaskFromST(UpdateTask.id, payload);
      if (success) {
         handleClose();
      }
   };

   return (
      <div>
         <Button
            variant="primary"
            style={{ margin: "10px" }}
            disabled={isLoading}
            onClick={() => setModalShow(true)}
         >
            <BorderColorIcon />
         </Button>

         <Modal
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={modalShow}
            onHide={handleClose}
         >
            <Modal.Header closeButton>
               <Modal.Title id="contained-modal-title-vcenter">
                  Modifier tâche
               </Modal.Title>
            </Modal.Header>
            <Modal.Body>
               <Form noValidate method="POST" onSubmit={handleSubmit}>
                  <Row className="mb-3">
                     <Form.Group as={Col} md="4" controlId="validationCustom01">
                        <Form.Label>Nom client : </Form.Label>
                        <Form.Control
                           required
                           type="text"
                           name="client_name"
                           autoComplete="off"
                           value={UpdateTask.client_name}
                           onChange={handleChange}
                        />
                     </Form.Group>
                     <Form.Group as={Col} md="4" controlId="validationCustom02">
                        <Form.Label>Telephone client : </Form.Label>
                        <Form.Control
                           type="text"
                           name="phoneNumber"
                           autoComplete="off"
                           value={UpdateTask.phoneNumber ? UpdateTask.phoneNumber : ""}
                           onChange={handleChange}
                        />
                     </Form.Group>
                     <Form.Group as={Col} md="4" controlId="validationCustom03">
                        <Form.Label>Type du tâche : </Form.Label>
                        <Form.Control
                           type="text"
                           name="catache"
                           list="dataTaskForST"
                           autoComplete="off"
                           value={UpdateTask.catache}
                           onChange={handleChange}
                        />
                        <datalist id="dataTaskForST">
                           {NewTask &&
                              NewTask.TypesTasks.map((TypesTask, index) => (
                                 <option key={index}>{TypesTask.catache}</option>
                              ))}
                        </datalist>
                     </Form.Group>
                  </Row>

                  <Row className="mb-3">
                     <Form.Group as={Col} md="4" controlId="validationCustom04">
                        <Form.Label>Date prévisionnelle début : </Form.Label>
                        <Form.Control
                           type="datetime-local"
                           name="date_previsionnelle_debut"
                           autoComplete="off"
                           value={
                              UpdateTask.date_previsionnelle_debut
                                 ? UpdateTask.date_previsionnelle_debut
                                 : ""
                           }
                           onChange={handleChange}
                        />
                     </Form.Group>
                     <Form.Group as={Col} md="4" controlId="validationCustom05">
                        <Form.Label>Affectée à : </Form.Label>
                        <Form.Control
                           type="text"
                           name="user_name"
                           list="userListForST"
                           autoComplete="off"
                           value={UpdateTask.user_name}
                           onChange={handleChange}
                        />
                        <datalist id="userListForST">
                           {filteredUsers.map((user, index) => (
                              <option key={index}>{user.name}</option>
                           ))}
                        </datalist>
                     </Form.Group>
                     <Form.Group as={Col} md="4" controlId="validationCustom06">
                        <Form.Label>Réalisée à : </Form.Label>
                        <Form.Select
                           name="cityClient"
                           autoComplete="off"
                           value={UpdateTask.cityClient || ""}
                           onChange={handleChange}
                        >
                           <option value="">
                              {currentCity && currentCity.cityName
                                 ? currentCity.cityName
                                 : "sélectionner ville"}
                           </option>
                           {NewTask &&
                              NewTask.Cities.map((city, index) => (
                                 <option key={index} value={city.id}>
                                    {city.cityName}
                                 </option>
                              ))}
                        </Form.Select>
                     </Form.Group>
                  </Row>

                  <Row className="mb-3">
                     <Form.Group as={Col} controlId="validationCustom07">
                        <Form.Label>Observation : </Form.Label>
                        <Form.Control
                           as="textarea"
                           rows={3}
                           type="text"
                           name="observation"
                           autoComplete="off"
                           value={
                              UpdateTask.observation
                                 ? UpdateTask.observation
                                 : ""
                           }
                           onChange={handleChange}
                        />
                     </Form.Group>
                  </Row>

                  <Modal.Footer>
                     <Button
                        type="submit"
                        className="Modelbutton"
                        variant="primary"
                        disabled={isLoading}
                     >
                        {!isLoading ? (
                           "Enregistrer les modifications"
                        ) : (
                           <div
                              style={{
                                 display: "flex",
                                 alignItems: "center",
                                 justifyContent: "center",
                                 gap: "2px",
                              }}
                           >
                              en cours <ThreeDot />
                           </div>
                        )}
                     </Button>
                  </Modal.Footer>
               </Form>
            </Modal.Body>
         </Modal>
      </div>
   );
};

export default UpdateTaskToConfirmed;
